import {Component} from '@angular/core';
import {ApiService} from '../../services/api.service';
import {Router} from '@angular/router';
import {ToastrService} from 'ngx-toastr';
import {FormBuilder, FormGroup, ReactiveFormsModule, Validators} from '@angular/forms';
import {FaIconLibrary, FontAwesomeModule} from '@fortawesome/angular-fontawesome';
import {faCheck, faSquarePlus, faSquareXmark} from '@fortawesome/free-solid-svg-icons';
import {CommonModule} from '@angular/common';

@Component({
    selector: 'app-add-black-listed-vehicle',
    imports: [CommonModule, ReactiveFormsModule, FontAwesomeModule],
    templateUrl: './add-black-listed-vehicle.component.html',
    styleUrl: './add-black-listed-vehicle.component.css'
})
export class AddBlackListedVehicleComponent {
  blackListForm: FormGroup;

  
  constructor(private apiService: ApiService, private router: Router, private toastr:ToastrService, fb: FormBuilder, library: FaIconLibrary) {
    library.addIcons(faCheck,
                    faSquareXmark,
                    faSquarePlus  
                  )
    

    this.blackListForm = fb.group({
      vehicleNumber: ['', Validators.required],
        personName: [''],
      reason: ['', [Validators.required, Validators.maxLength(300)]]
    });
  }

  // get vehicleNumber() {
  //   return this.blackListForm.get('vehicleNumber');
  // }

  // get newPassword() {
  //   return this.blackListForm.get('newPassword');
  // }

  // get confirmNewpassword() {
  //   return this.blackListForm.get('confirmNewpassword');
  // }


  onSubmit() {
    if (this.blackListForm.valid) {
      let formdata = new FormData();
      formdata.append('vehicle_number', this.blackListForm.value.vehicleNumber);
        if (this.blackListForm.value.personName) {
            formdata.append('person_name', this.blackListForm.value.personName);
        }
      formdata.append('reason', this.blackListForm.value.reason);
      formdata.append('is_active', 'true');
      this.apiService.addBlackListedVehicle(formdata).subscribe({
          next: (response:any) => {
            this.toastr.success("The given Vehicle is added in blacklist successfully.", 'Success');
            this.router.navigate(['/blacked-vehicle']);
          },
          error: (err) => {
            if (err['error']['non_field_errors']) {
              err['error']['non_field_errors'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            }else if (err['error']['vehicle_number']) {
              err['error']['vehicle_number'].forEach((element:any) => {
                this.toastr.error(element, 'Error');
              });
            } else if (err['status'] !== 403 && err.status !== 0) {
              this.toastr.error("Something went wrong!", 'Error');
            }
          }
        }
      )
    } else {
      this.validateAllFormFields(this.blackListForm);
    }
  }
  validateAllFormFields(formGroup: FormGroup) {   
    Object.keys(formGroup.controls).forEach(field => {  
      const control = formGroup.get(field);             
      if (control instanceof FormGroup) {        
        this.validateAllFormFields(control);            
      } else {                                      
        control?.markAsTouched({ onlySelf: true });
      }
    });
  }

  onCancel() {
    this.router.navigate(['/blacked-vehicle']);

  }

}
